module.exports = __webpack_public_path__ + "img/button-click@2x.4cef4eac.png";